var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFalse = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9A9A9A",
    fillRule: "evenodd",
    d: "M5 7.333A2.333 2.333 0 0 1 7.333 5h9.334A2.333 2.333 0 0 1 19 7.333v9.334A2.333 2.333 0 0 1 16.667 19H7.333A2.333 2.333 0 0 1 5 16.667zm11.13.549a.875.875 0 0 0-1.237 0l-2.851 2.851-2.854-2.851a.875.875 0 1 0-1.236 1.236l2.851 2.853-2.921 2.922a.875.875 0 1 0 1.236 1.237l2.924-2.922 2.921 2.923a.876.876 0 0 0 1.504-.616.88.88 0 0 0-.267-.622l-2.921-2.923 2.852-2.852a.875.875 0 0 0 0-1.236z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFalse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/false.0bbe560f.svg";